// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles__icon___j5b7N","control":"styles__control___3yijl styles__icon___j5b7N","controls":"styles__controls___36GZ1"};